import { render, staticRenderFns } from "./UploadLeads.vue?vue&type=template&id=73214ae6&"
import script from "./UploadLeads.vue?vue&type=script&lang=ts&"
export * from "./UploadLeads.vue?vue&type=script&lang=ts&"
import style0 from "./UploadLeads.vue?vue&type=style&index=0&id=73214ae6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports